import { useForm } from "react-hook-form";
import { AddIcon, ArrowBackIcon, CalendarIcon, CheckIcon, ChevronRightIcon, DeleteIcon, EditIcon } from '@chakra-ui/icons'
import {  Box, Button, Checkbox, CheckboxGroup, Container, FormControl, FormLabel, HStack, IconButton, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Select, Spinner, Stack, Tab, TabList, Tabs, Text, useDisclosure, useToast, VStack } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDoorData } from '../context/DoorContext'
import TimeRangePicker from '@wojtekmaj/react-timerange-picker';

function DoorTimePage() {

  const { user, loading, axiosJWT, allDoors, getAllDoors, allCardGroups, getAllCardGroups } = useDoorData()
  const toast = useToast()
  const navigate = useNavigate()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { register, handleSubmit, formState: { isSubmitting }, reset } = useForm();
 

  const [selectedGroupDoors, setSelectedGroupDoors] = useState([]);
  const [selectedDoorTimes, setSelectedDoorTimes] = useState([]);
  const [currCardGroup, setCurrCardGroup] = useState(allCardGroups[0]?.id);
  const [currDoor, setCurrDoor] = useState(null);
  // For doortime checkboxes values
  const [editTimeCheckboxes,setEditTimeCheckboxes] = useState([]);
  const [editTimeRange, setEditTimeRange] = useState([]);
  const [editTimeBox, setEditTimeBox] = useState(false);

  const [showAddTime, setShowAddTime] = useState(false);


  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user])

  useEffect(() => {
    getAllDoors()
    getAllCardGroups()
    getGroupDoors(allCardGroups[0]?.id)
  }, [])


  useEffect(() => {
    getGroupDoors(currCardGroup);
  }, [currCardGroup])


  const getGroupDoors = async pGroupID => {
    await axiosJWT.post(`/check_group_doors`, { pGroupID: pGroupID }).then((response) => {
      setSelectedGroupDoors(response.data)


    });
  }

  const unusedGroupDoors = () => {
    const unusedDoors = allDoors.filter(e => !selectedGroupDoors.some(a => a.DoorID === e.DoorID))
    return unusedDoors
  }

  const getDoorTimes = async (pGroupID, DoorID) => {
    console.log('groupid')
    console.log(pGroupID);
    await axiosJWT.post(`/check_group_door_times`, { pGroupID: pGroupID, DoorID: DoorID }).then((response) => {
      setSelectedDoorTimes(response.data)
    });
  }


  const onDoorSubmit = async data => {
    try {
      const res = await axiosJWT.put("/api/doortime/create", { DoorID: data.DoorID, pGroupID: currCardGroup })
      if (res) {
        toast({
          title: '👋 Duru grupė pridėta!',
          position: 'bottom',
          status: 'success',
          isClosable: true,
          duration: 4000
        })
        getGroupDoors(currCardGroup);
        onClose();
        reset();

      }

    } catch (err) {
      console.log(err.response.data);
      toast({
        title: err.response.data,
        position: 'bottom',
        status: 'error',
        isClosable: true,
        duration: 4000
      })

    }

  };

  const addDoorTime = async () => {
    try {
      const res = await axiosJWT.put("/api/doortime/create", { DoorID: currDoor, pGroupID: currCardGroup })
      if (res) {
        toast({
          title: '👋 Duru laikas pridėtas!',
          position: 'bottom',
          status: 'success',
          isClosable: true,
          duration: 4000
        })
        getGroupDoors(currCardGroup);
        getDoorTimes(currCardGroup, currDoor);

      }

    } catch (err) {
      console.log(err.response.data);
      toast({
        title: err.response.data,
        position: 'bottom',
        status: 'error',
        isClosable: true,
        duration: 4000
      })
    }
  };


  const deleteDoorTime = async (doortimeID) => {
    try {
      const res = await axiosJWT.delete(`/api/doortime/delete/${doortimeID}`)
      if (res) {
        toast({
          title: '👋 Duru laikas ištrintas!',
          position: 'bottom',
          status: 'success',
          isClosable: true,
          duration: 4000
        })
        getGroupDoors(currCardGroup);
        getDoorTimes(currCardGroup, currDoor);

      }

    } catch (err) {
      console.log(err.response.data);
      toast({
        title: err.response.data,
        position: 'bottom',
        status: 'error',
        isClosable: true,
        duration: 4000
      })
    }
  };

  const editDoorTime = async (doortimeID, checkboxes, time)  => {

    if( time == null  || time[0] < time[1] ){
     
    try {
      const res = await axiosJWT.put("/api/doortime/edit", { doortimeID, checkboxes, time })
      if (res) {
        toast({
          title: '👋 Praėjimo laikas redaguotas!',
          position: 'bottom',
          status: 'success',
          isClosable: true,
          duration: 4000
        })
        getGroupDoors(currCardGroup);
        getDoorTimes(currCardGroup, currDoor);
        setEditTimeBox(false); 
      }

    } catch (err) {
      console.log(err.response.data);
      toast({
        title: err.response.data,
        position: 'bottom',
        status: 'error',
        isClosable: true,
        duration: 4000
      })
      setEditTimeBox(false); 

    }
     
  }else{
    toast({
      title: 'Iki laikas turi būti didesnis už pradžios laiką!',
      position: 'bottom',
      status: 'error',
      isClosable: true,
      duration: 4000
    })
  }


  };

  



  return (
    <>


      <Tabs mx={'5rem'} orientation='vertical' variant='unstyled'>
        <TabList >
          {allCardGroups.map((cardGroup) => {

            return <Tab justifyContent={'left'} borderRadius={'0.3rem'} key={cardGroup.id} onClick={() => { setCurrCardGroup(cardGroup.id); setShowAddTime(false); setCurrDoor(null); setSelectedDoorTimes([]) }} _selected={{ color: 'white', bg: 'green.500' }} > <ChevronRightIcon mr={'0.2rem'} />{cardGroup.name}</Tab>
          })}

        </TabList>

        <VStack w={'45%'} alignItems={'flex-start'}>
        <Container>
          {unusedGroupDoors().length !== 0 && <Button onClick={() => { onOpen(); }} width={'100%'} mb={'1rem'} leftIcon={<AddIcon />} colorScheme={'green'}>Pridėti duris grupei</Button>}

          {selectedGroupDoors.length !== 0 ? selectedGroupDoors.map((door, index) => {

            return (


              <Box mb={'0.5rem'} key={index} position={'relative'} borderRadius={'1rem'} overflow={'hidden'} border={currDoor === door.DoorID ? '0.2rem solid #38a169' : '0.2rem solid #ddd'} w={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'} cursor={'pointer'}
                onClick={() => { getDoorTimes(door.pGroupID, door.DoorID); setCurrDoor(door.DoorID); setShowAddTime(true) }} height='80px'>
                <HStack>
                  <Box p={'2rem'} position={'absolute'} left={'0'} bg={currDoor === door.DoorID ? 'green.500' : '#ddd'}><CalendarIcon color={'#fff'} /></Box>

                  <Text fontSize={'md'} fontWeight={'500'}>{door.DoorName}</Text>
                </HStack>
              </Box>
            )

            

          }) : <Container><Text mt={'5rem'}>Durų laikų šiai grupei nėra, pridėkite!</Text>
            <Button mt={'2rem'} onClick={() => { onOpen(); }} ml={'1.5rem'} leftIcon={<AddIcon />} colorScheme={'green'}>Pridėti duris grupei</Button></Container>}
            </Container>
        </VStack>
        <VStack w={'50%'}>
        {showAddTime && <Container>
             <Button mb={'1rem'} w={'100%'} leftIcon={<AddIcon />} colorScheme={'green'} onClick={() => { addDoorTime(); }} >Pridėti laiką grupės durims</Button>
          </Container>}
          <Container height={'74vh'} overflow={'auto'}>
            {selectedDoorTimes.map((doortime) => {

              const whichWeekDaysIsActive = doortime.weekday_id
                .split(',')
                .filter(val => val !== '0')
                .sort((a, b) => a - b)


              return <Box mb={'0.5rem'} borderRadius={'1rem'} overflow={'hidden'} onDoubleClick={() => { setEditTimeBox(doortime.ID); setEditTimeCheckboxes(whichWeekDaysIsActive); setEditTimeRange([doortime.start_time, doortime.end_time]); }} key={doortime.ID} position={'relative'} border={editTimeBox === doortime.ID ? '0.2rem solid #38a169' : '0.2rem solid #ddd'} w='100%' p={4}>
                {editTimeBox !== doortime.ID && <IconButton onClick={() => { setEditTimeBox(doortime.ID); setEditTimeCheckboxes(whichWeekDaysIsActive); setEditTimeRange([doortime.start_time, doortime.end_time]) }} icon={<EditIcon />} position={'absolute'} right={'0'} top={'0'} borderRadius={'0 0 0 1rem'} />}
                {editTimeBox === doortime.ID && <IconButton onClick={() => { setEditTimeBox(false); setEditTimeCheckboxes([]) }} icon={<ArrowBackIcon />} position={'absolute'} right={'0'} top={'0'} borderRadius={'0 0 0 1rem'} />}
                <Text fontSize={'sm'} textAlign={'left'} userSelect={'none'}>Valandos kuriomis leisti nuo — iki :</Text>
                {editTimeBox !== doortime.ID ? doortime.start_time !== null ? <Text>{doortime.start_time} — {doortime.end_time}</Text> : <Text>Nėra priskirta</Text> : 
                <TimeRangePicker locale={'lt-LT'} format={'HH:mm:ss'} maxDetail={'second'} disabled={editTimeBox === doortime.ID ? false : true} onChange={setEditTimeRange} disableClock={true} value={editTimeRange} />}
                <Text fontSize={'sm'} textAlign={'left'}>Kuriomis savaitės dienomis leisti:</Text>
                <CheckboxGroup colorScheme='green' defaultValue={whichWeekDaysIsActive} onChange={(e) => {
                  const editedCheckboxes = e
                  .filter(val => val !== '0')
                  .sort((a, b) => a - b)
                  setEditTimeCheckboxes(editedCheckboxes);
                }}>

                  <Stack mb={'0.5rem'} overflow={'auto'} spacing={[1, 5]} direction={['column', 'row']}>
                    <Checkbox disabled={editTimeBox === doortime.ID ? false : true} value='1'>Pr</Checkbox>
                    <Checkbox disabled={editTimeBox === doortime.ID ? false : true} value='2'>An</Checkbox>
                    <Checkbox disabled={editTimeBox === doortime.ID ? false : true} value='3'>Tr</Checkbox>
                    <Checkbox disabled={editTimeBox === doortime.ID ? false : true} value='4'>Kt</Checkbox>
                    <Checkbox disabled={editTimeBox === doortime.ID ? false : true} value='5'>Pn</Checkbox>
                    <Checkbox disabled={editTimeBox === doortime.ID ? false : true} value='6'>Št</Checkbox>
                    <Checkbox disabled={editTimeBox === doortime.ID ? false : true} value='7'>Sk</Checkbox>
                  </Stack>
                </CheckboxGroup>
                {editTimeBox === doortime.ID && <HStack position={'absolute'} right={'0'} bottom={'0'} >
                  <IconButton borderRadius={'0.5rem 0.5rem 0 0'} onClick={() => { deleteDoorTime(doortime.ID); setEditTimeBox(false); }} icon={<DeleteIcon />} colorScheme={'red'} />
                  <IconButton margin={'0'} borderRadius={'1rem 0 0 0'} onClick={() => {
                     editDoorTime(doortime.ID, editTimeCheckboxes, editTimeRange) 
                     }} icon={<CheckIcon />} colorScheme={'green'} />
                </HStack>}
              </Box>
            })}
          </Container>
        </VStack>

      </Tabs>





      {/* Modal */}


      <Modal isCentered isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>

          <ModalHeader>{'Pridėti duris grupei'}</ModalHeader>

          <ModalCloseButton />
          <ModalBody m={'1rem'}>
            {loading ?
              <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor='gray.200'
                color='green.500'
                size='xl'
              />
              :
              <form onSubmit={handleSubmit(onDoorSubmit)}>
                <FormControl maxW={'30rem'} >
                  <FormLabel>Durys</FormLabel>
                  <Select placeholder='Pasirinkite duris grupei' {...register("DoorID")}>
                    {
                      unusedGroupDoors().map((door, index) => {
                        return <option key={index} value={door.DoorID}>{door.DoorName}</option>

                      })
                    }

                  </Select>

                  {/* <FormLabel>Kortelės numeris</FormLabel>
                  <Input autoComplete="off" mb={'1rem'} id='cardno' {...register("cardno")} name='cardno' type='text' /> */}
                  <Button mt={'1rem'} width={'100%'} colorScheme={'green'} isLoading={isSubmitting} type={'submit'} >{'Pridėti duris grupei'}</Button>
                </FormControl>
              </form>

            }

          </ModalBody>
        </ModalContent>
      </Modal>

    </>




  )
}

export default DoorTimePage